import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './icon-button.style.js'
import { classMap } from 'lit/directives/class-map.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


export const iconButtonVariants = ['primary', 'secondary', 'ghost'] as const
export type iconButtonVariantTypes = typeof iconButtonVariants

export const iconButtonSizes = ['default', 'small'] as const
export type iconButtonSizeTypes = typeof iconButtonSizes

initializeIconsByRole({
  'cse-icon-button.clear': { name: 'xmark', style: 'light' },
})

@customElement('cse-icon-button')
export class CSEIconButton extends LitElement {
  static override styles: CSSResultGroup = [fontStyles, hostStyle, style]

  @property()
  variant: iconButtonVariantTypes[number] = 'primary'

  @property({ type: String })
  size: iconButtonSizeTypes[number] = 'default'

  @property({ type: Boolean })
  disabled = false

  @property({ type: Boolean })
  error = false

  @property({ type: Boolean })
  shadow = false

  @property({ type: String, attribute: 'aria-label' })
  override ariaLabel = ''

  override render() {
    return html`
      <button
        type="button"
        class="${classMap({
          'cse-icon-button': true,
          'font-body': true,
          [`variant-${this.variant}`]: true,
          [`size-${this.size}`]: true,
          'shadow': this.shadow
        })}"
        aria-label="${this.ariaLabel}"
        ?error=${this.error}
        ?disabled=${this.disabled}
      >
        <slot class="icon">
          <cse-icon icon-role="cse-icon-button.clear" size="${this.variant === 'ghost' ? 'md' : this.size === 'default' ? 'md' : 'xs'}"></cse-icon>
        </slot>
      </button>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-icon-button': CSEIconButton
  }
}
